import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { GridConfiguration } from '../../../types/grid-configuration.type';

@Component({
  selector: 'app-lot-add-photo-images-sorter',
  templateUrl: './lot-add-photo-images-sorter.component.html',
  styleUrls: ['./lot-add-photo-images-sorter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoImagesSorterComponent {
  @Input() initialImages: string[] = [];
  @Input() noAuctionList = false;
  @Input() grid: GridConfiguration;
  @Input() itemHeightPx: number;
  @Output() images = new EventEmitter<string[]>();
  @Output() hasSelected = new EventEmitter<boolean>();

  selectedImages: string[] = [];

  constructor(private readonly cdr: ChangeDetectorRef) {}

  select(image: string): void {
    this.selectedImages = [...this.selectedImages, image];
    this.emitSortingImages();
  }

  unselect(image: string): void {
    this.selectedImages = this.selectedImages.filter((img) => img !== image);
    this.emitSortingImages();
  }

  tackByImage(_: number, image: string): string {
    return image;
  }

  getIndex(image: string): number | null {
    const index = this.selectedImages.indexOf(image);
    return index === -1 ? null : index;
  }

  resetSelected(): void {
    this.selectedImages = [];
    this.cdr.markForCheck();
  }

  isAuctionList(image: string): boolean {
    const index = this.getIndex(image);
    return index === 0 && !this.noAuctionList;
  }

  private emitSortingImages(): void {
    const otherImages = this.initialImages.filter((image) => !this.selectedImages.includes(image));
    const sortedImages = [...this.selectedImages, ...otherImages];

    this.images.emit(sortedImages);
    this.hasSelected.emit(this.hasSelectedImages);
  }

  private get hasSelectedImages(): boolean {
    return !!this.selectedImages.length;
  }

  get lasIndex(): number | null {
    const length = this.selectedImages.length;
    return length ? length - 1 : null;
  }
}
